

import HeaderDashboard from "../../Components/HeaderDashboard";
import React, { useEffect, useState, useRef , useContext} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FlightBookingDetails,FlightTransactionDetails, RescheduleRequest } from "../../Services/API";
import { AuthContext } from "../../Routes/AuthProvider"

const ReSchedule = () => {
 const { userName } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo = queryParams.get("ReferenceNo");
  const trackId = queryParams.get("trackID");

  const [flightDetails, setFlightDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [comments, setComments] = useState("");

  useEffect(() => {
    if (referenceNo && trackId) {
      fetchFlightBookingDetails(referenceNo, trackId);
    } else {
      console.warn("Missing referenceNo and trackId");
    }
  }, [referenceNo, trackId]);

  const fetchFlightBookingDetails = async (referenceNo, trackId) => {
    try {
      setLoading(true);
      setError("");
      const params = { ReferenceNo: referenceNo, TrackID: trackId, ClientCode: "BerryJourneys", Key: "", SessionID: "" };
      const response = await FlightTransactionDetails(params);
      setFlightDetails(response);
      //console.log(response)
    } catch (err) {
      setError("Failed to load flight Booking details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ReSchedule start

  const [travelDate, setTravelDate] = useState("");
  const [nextTravelDate, setNextTravelDate] = useState("");
  const [selectedTickets, setSelectedTickets] = useState([]);

  const handlePassengerSelect = (ticketIndex) => {
    setSelectedTickets(prev => {
      if (prev.includes(ticketIndex)) {
        return prev.filter(id => id !== ticketIndex);
      } else {
        return [...prev, ticketIndex];
      }
    });
  };

  const SubmitRescheduleRequest = async () => {
    if (!selectedTickets.length) {
      alert("Please select at least one passenger");
      return;
    }

    if (!nextTravelDate) {
      alert("Please select next travel date");
      return;
    }

    try {
      setLoading(true);
      const requestBody = {
        key: "",
        userID: userName,
        clientCode: "BerryJourneys",
        referenceNo: referenceNo,
        trackIDs: flightDetails?.airBookingResponse[0]?.flightDetails[0]?.trackID,
        ticketIndexs: selectedTickets.toString(),
        rescheduleRemarks: comments,
        reScheduleDate: nextTravelDate
      };

      const response = await RescheduleRequest(requestBody);
      if (response.status === "RequestSubmitted") {
        alert("Ticket Reschedule Request submitted successfully");
        navigate(
          `/Reservations/Flight/TransactionDetails?referenceNo=${referenceNo}`
        );

      } else {
        alert("Oops, action not completed.!!");
      }
    } catch (error) {
      alert("Reschedule request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <HeaderDashboard></HeaderDashboard>
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">My Booking</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item">
                  <a href="/reservations/flight/ReSchedule" className="text-muted text-hover-primary">Booking Re-Schedule</a>
                </li>

              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="flex-shrink-0">
              <ul class="nav" role="tablist">
                <li class="nav-item" role="presentation">
                  <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                    <img src="/assets/images/back.png" className="imgBack" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row">
            {/* Ticket details */}
            {flightDetails && flightDetails.airBookingResponse.length > 0 ? (
              <>
                <div class="row mamage_depo">
                  <div class="col-lg-6">
                    <h6 className='ruler'>Flight Re-Schedule</h6>
                  </div>

                </div>

                <div className='col-md-12 col-lg-12'>
                  <div className='table-responsive'>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>Reference No</th>
                          <th>Confirmation Number (PNR)</th>
                          <th>Booking Status</th>
                          <th>Ticketing Status</th>
                          <th>Booking Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{flightDetails.referenceNo}</td>
                          <td>{flightDetails.airBookingResponse[0].pnr}</td>
                          <td>{flightDetails.airBookingResponse[0].bookingStatus}</td>
                          <td>{flightDetails.airBookingResponse[0].ticketingStatus}</td>
                          <td>{flightDetails.airBookingResponse[0].bookingDate}</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Travel Information</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>Travel Date</th>
                          <th>Flight No.</th>
                          <th>Aircraft Type</th>
                          <th>From / Terminal </th>
                          <th>To / Terminal</th>
                          <th>Dep Time</th>
                          <th>Arr Time</th>
                          <th>Airline</th>
                        </tr>
                        {flightDetails?.airBookingResponse?.map((bookingResponse, bookingIndex) => (
                          bookingResponse?.flightDetails?.map((flight, flightIndex) => (
                            <tr key={`${bookingIndex}-${flightIndex}`}>
                              <td>
                                {new Date(flight.departDateTime).toLocaleDateString("en-US", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric"
                                }).replace(",", " ,")}
                              </td>
                              {/* <td>{flight.DepartDateTime}</td> */}
                              <td>{flight.airLineCode} - {flight.flightNumber}</td>
                              <td><samp>N/A</samp></td>
                              <td class="dropdown-caps">{flight.departAirportCode} <span>:{flight.departTerminal}</span></td>
                              <td class="dropdown-caps">{flight.arrivalAirportCode} <span>:{flight.arrivalTerminal}</span></td>
                              <td>
                                {new Date(flight.departDateTime).toLocaleString("en-GB", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </td>

                              <td>
                                {new Date(flight.arrivalDateTime).toLocaleString("en-GB", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </td>
                              <td>{flight.airLineName}</td>
                            </tr>
                          ))
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>



              </>
            ) : (
              !loading && flightDetails && (
                <>
                  <div class="row mamage_depo">
                    <div class="col-lg-12">
                      <h6 className='ruler'>Flight Booking Details</h6>
                    </div>
                    <div class="col-lg-12">
                      <p className=''>No Flight Booking Details Found !!</p>
                    </div>
                  </div>
                </>
              )
            )}

            <div className="col-lg-12">
              <h6 className="ruler">Re-Schedule Ticket</h6>
            </div>
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Re-Schedule<span className="required"></span></th>
                      <th>Name</th>
                      <th>Pax Type</th>
                      <th>Ticket ID</th>
                      <th>E-Ticket No</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerTicketDetails?.map((pax, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            className="checkBox"
                            checked={selectedTickets.includes(pax.ticketIndex)}
                            onChange={() => handlePassengerSelect(pax.ticketIndex)}
                          />
                        </td>
                        <td>
                          {pax.title}. {pax.firstName} {pax.lastName}
                        </td>
                        <td>{pax.paxTypeCode}</td>
                        <td>{pax.ticketID}</td>
                        <td>{pax.ticketNumber}</td>
                        <td>{pax.status}</td>
                      </tr>
                    )
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* ---------------- Re-Schedule Date ---------------- */}

            <div className="col-md-12 col-lg-12">
              <h6 className="ruler mb-5">Re-Schedule Date</h6>

              <div className="row">
                <div className="col-md-3 d-none">
                  <label>Reference No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={referenceNo}
                    readOnly
                  />
                </div>

                <div className="col-md-3 d-none">
                  <label>Travel Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={travelDate}
                    readOnly
                  />
                </div>

                <div className="col-md-3">
                  <label>
                    Next Travel Date<span className="required"></span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={nextTravelDate}
                    min={travelDate}
                    onChange={(e) => setNextTravelDate(e.target.value)}
                  />
                </div>

                <div className="col-md-12">
                  <label>Write Comments</label>
                  <textarea
                    className="form-controls"
                    rows="3"
                    placeholder="Comments.."
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </div>

                <div className="col-md-12 mb-3 text-end">
                  <button
                    type="button"
                    className="btn btn-primary mt-2"
                    onClick={SubmitRescheduleRequest}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit Reschedule Request"}
                  </button>
                </div>
              </div>
            </div>





          </div>

        </div>
      </section>

    </>
  );
};

export default ReSchedule;